import type { ProviderType } from '@/lib/api/provider-types'

export interface ProviderFieldSchema {
  key: string
  label: string
  required: boolean
  secret?: boolean
  placeholder?: string
}

export interface ProviderSchema {
  label: string
  description: string
  credentials: ProviderFieldSchema[]
  config: ProviderFieldSchema[]
  native?: boolean
  perks?: string[]
}

export const PROVIDER_SCHEMAS: Record<ProviderType, ProviderSchema> = {
  tixr: {
    label: 'Tixr',
    description: 'Connect your Tixr events for automatic ticket syncing',
    credentials: [
      { key: 'api_key', label: 'API Key', required: true, secret: true },
    ],
    config: [],
  },
  ticketlabs: {
    label: 'TicketLabs',
    description: 'Sync tickets and attendees from TicketLabs',
    credentials: [
      { key: 'api_key', label: 'API Key', required: true, secret: true },
    ],
    config: [],
    native: true,
    perks: ['No token fees'],
  },
  eventbrite: {
    label: 'Eventbrite',
    description: 'Import attendees and ticket types from Eventbrite',
    credentials: [
      { key: 'access_token', label: 'Access Token', required: true, secret: true },
    ],
    config: [
      { key: 'org_id', label: 'Organization ID', required: true },
    ],
  },
}

export const PROVIDER_TYPES: ProviderType[] = ['ticketlabs', 'tixr', 'eventbrite']
